export const ErrorPage = () => {
    return(
        <> You seem lost</>
    )
}